export default __webpack_public_path__ + "static/oliver-19ccc23d4393d04f9a3a5cb12a4a20d6.jpg";